import * as React from 'react';

import { diag, DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api';

import { config } from '~/config';

// Initialize Faro once
const faro = null;
// config.openTelemetry.enabled
//   ? initializeFaro({
//       url: `${config.openTelemetry.collector}/collect`,
//       app: {
//         name: config.service.name,
//         version: config.service.version,
//         environment: config.environment,
//       },
//       instrumentations: [
//         ...getWebInstrumentations(),
//         new TracingInstrumentation({
//           instrumentationOptions: {
//             propagateTraceHeaderCorsUrls: [
//               // Enable trace propagation for our API endpoints
//               new RegExp(config.api.url),
//             ],
//           },
//         }),
//       ],
//     })
//   : null;

diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.DEBUG);

export const TelemetryProvider = ({ children }: React.PropsWithChildren) => {
  if (
    !config.openTelemetry.enabled ||
    !config.openTelemetry.collector ||
    !faro
  ) {
    return children;
  }

  return (
    // <PostHogProvider
    //   apiKey={config.posthog.key}
    //   options={{
    //     api_host: config.posthog.host,
    //     ...config.posthog.options,
    //     bootstrap: {
    //       distinctID: undefined, // Will be set when user is identified
    //       isIdentifiedID: false,
    //       featureFlags: {},
    //     },
    //   }}
    // >
    children
    // </PostHogProvider>
  );
};
